const FlagLocalhost = () => {
	const incomingString = localStorage.getItem("evidya_data")!;
	const incomingdata = JSON.parse(incomingString);

	return incomingdata;
};

export default FlagLocalhost;
